// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-product-modal-modal_card-iog7H {
  width: 340px;
  height: auto;
  max-height: 680px;
}

.edit-product-modal-modal_content-TQ9bM {
  overflow: scroll;
  padding: 0px 10px 4px 20px;
}

.edit-product-modal-textField_container-_oqo4,
.edit-product-modal-textArea_container-ixYun,
.edit-product-modal-select_container-ENsyd,
.edit-product-modal-priceField_container-ptNUm,
.edit-product-modal-autocomplete_container-4Znei,
.edit-product-modal-imageField-WgCwj {
  width: 100%;
  margin-top: 20px;
}

.edit-product-modal-priceField_iconContainer-vzF4t {
  padding-right: 8px;
}

.edit-product-modal-select_popup-lFZSK {
  max-height: 400px;
}

.edit-product-modal-textArea_input-gbDSR {
  height: 64px;
}

.edit-product-modal-autocomplete_popup-u3QGH {
  max-height: 280px;
}

.edit-product-modal-priceField_iconContainer-vzF4t {
  padding-right: 8px;
}

.edit-product-modal-addPriceIcon-uAeN9 {
  width: fit-content;
  height: fit-content;
  font-size: 24px;
  color: var(--color-neutral-500);
  padding: 4px;
}

.edit-product-modal-addPriceIcon-uAeN9:hover {
  color: var(--color-neutral-600);
}

.edit-product-modal-addPriceIcon-uAeN9:active {
  color: var(--color-neutral-800);
}

.edit-product-modal-prices-o6CFG {
  display: flex;
  flex-flow: row wrap;
  gap: 6px;
  margin-top: 12px;
}

.edit-product-modal-priceItem-UaqCJ {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0px;
  cursor: pointer;
  background-color: var(--color-green-100);
  border-radius: 20px;
  transition: gap 200ms ease, padding-right 200ms ease;
  padding: 6px 12px;
}

.edit-product-modal-priceItem-UaqCJ:hover {
  gap: 8px;
  padding-right: 10px;
}

.edit-product-modal-priceValue-CD6R_ {
  color: var(--color-green-950);
}

.edit-product-modal-priceDeleteIcon-yoUP3 {
  width: 0px;
  height: fit-content;
  font-size: 18px;
  color: var(--color-green-900);
  opacity: 0;
  transition: width 200ms ease, visibility 200ms 200ms ease;
}

.edit-product-modal-priceItem-UaqCJ:hover .edit-product-modal-priceDeleteIcon-yoUP3 {
  width: 18px;
  opacity: 0.8;
}

.edit-product-modal-priceItem-UaqCJ:hover .edit-product-modal-priceDeleteIcon-yoUP3:hover {
  opacity: 1;
}

.edit-product-modal-priceDeleteIcon-yoUP3:active {
  opacity: 1;
  color: var(--color-black);
}
`, "",{"version":3,"sources":["webpack://./src/pages/products/edit-product-modal/edit-product-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;;;;;EAME,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,QAAQ;EACR,eAAe;EACf,wCAAwC;EACxC,mBAAmB;EACnB,oDAAoD;EACpD,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,UAAU;EACV,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,yBAAyB;AAC3B","sourcesContent":[".modal_card {\n  width: 340px;\n  height: auto;\n  max-height: 680px;\n}\n\n.modal_content {\n  overflow: scroll;\n  padding: 0px 10px 4px 20px;\n}\n\n.textField_container,\n.textArea_container,\n.select_container,\n.priceField_container,\n.autocomplete_container,\n.imageField {\n  width: 100%;\n  margin-top: 20px;\n}\n\n.priceField_iconContainer {\n  padding-right: 8px;\n}\n\n.select_popup {\n  max-height: 400px;\n}\n\n.textArea_input {\n  height: 64px;\n}\n\n.autocomplete_popup {\n  max-height: 280px;\n}\n\n.priceField_iconContainer {\n  padding-right: 8px;\n}\n\n.addPriceIcon {\n  width: fit-content;\n  height: fit-content;\n  font-size: 24px;\n  color: var(--color-neutral-500);\n  padding: 4px;\n}\n\n.addPriceIcon:hover {\n  color: var(--color-neutral-600);\n}\n\n.addPriceIcon:active {\n  color: var(--color-neutral-800);\n}\n\n.prices {\n  display: flex;\n  flex-flow: row wrap;\n  gap: 6px;\n  margin-top: 12px;\n}\n\n.priceItem {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 0px;\n  cursor: pointer;\n  background-color: var(--color-green-100);\n  border-radius: 20px;\n  transition: gap 200ms ease, padding-right 200ms ease;\n  padding: 6px 12px;\n}\n\n.priceItem:hover {\n  gap: 8px;\n  padding-right: 10px;\n}\n\n.priceValue {\n  color: var(--color-green-950);\n}\n\n.priceDeleteIcon {\n  width: 0px;\n  height: fit-content;\n  font-size: 18px;\n  color: var(--color-green-900);\n  opacity: 0;\n  transition: width 200ms ease, visibility 200ms 200ms ease;\n}\n\n.priceItem:hover .priceDeleteIcon {\n  width: 18px;\n  opacity: 0.8;\n}\n\n.priceItem:hover .priceDeleteIcon:hover {\n  opacity: 1;\n}\n\n.priceDeleteIcon:active {\n  opacity: 1;\n  color: var(--color-black);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `edit-product-modal-modal_card-iog7H`,
	"modal_content": `edit-product-modal-modal_content-TQ9bM`,
	"textField_container": `edit-product-modal-textField_container-_oqo4`,
	"textArea_container": `edit-product-modal-textArea_container-ixYun`,
	"select_container": `edit-product-modal-select_container-ENsyd`,
	"priceField_container": `edit-product-modal-priceField_container-ptNUm`,
	"autocomplete_container": `edit-product-modal-autocomplete_container-4Znei`,
	"imageField": `edit-product-modal-imageField-WgCwj`,
	"priceField_iconContainer": `edit-product-modal-priceField_iconContainer-vzF4t`,
	"select_popup": `edit-product-modal-select_popup-lFZSK`,
	"textArea_input": `edit-product-modal-textArea_input-gbDSR`,
	"autocomplete_popup": `edit-product-modal-autocomplete_popup-u3QGH`,
	"addPriceIcon": `edit-product-modal-addPriceIcon-uAeN9`,
	"prices": `edit-product-modal-prices-o6CFG`,
	"priceItem": `edit-product-modal-priceItem-UaqCJ`,
	"priceValue": `edit-product-modal-priceValue-CD6R_`,
	"priceDeleteIcon": `edit-product-modal-priceDeleteIcon-yoUP3`
};
export default ___CSS_LOADER_EXPORT___;
